<template>
    <div class="footer-container">
        <div class="logo-wrapper">
            <img
                src="../../assets/images/footer_logo@2x.png"
                srcset="
                    ../../assets/images/footer_logo@2x.png 1200w,
                    ../../assets/images/footer_logo@3x.png  800w
                "
                alt="logo"
            />
        </div>
        <div class="tag-list">
            <router-link :to="{ path: '/contact' }" class="tag-item"
                >关于我们&nbsp;&nbsp;|&nbsp;&nbsp;</router-link
            >
            <router-link :to="{ path: '/intro?#companyInfo' }" class="tag-item"
                >公司简介&nbsp;&nbsp;|&nbsp;&nbsp;</router-link
            >
            <router-link :to="{ path: '/news' }" class="tag-item"
                >新闻动态&nbsp;&nbsp;|&nbsp;&nbsp;</router-link
            >
            <router-link :to="{ path: '/intro?#awards' }" class="tag-item"
                >荣誉奖项&nbsp;&nbsp;|&nbsp;&nbsp;</router-link
            >
            <router-link :to="{ path: '/intro?#featuredCase' }" class="tag-item"
                >成功案例</router-link
            >
            <!-- <router-link :to="{ path: '/intro' }" class="tag-item">政府支持重点项目</router-link> -->
        </div>
        <div class="link-info clearFix">
            <div class="link-method-item link-phone">
                咨询热线：<span>021-50504740</span>
            </div>
            <div class="link-method-item link-email">
                Email：<span>wwjdev@ywbjchina.com</span>
            </div>
            <div class="link-method-item link-address">
                地址：<span>中国（上海）自由贸易实验区海趣路58号</span>
            </div>
        </div>
        <div class="extro-desc">
            <div class="desc-item m-b-10">
                Copyright © 上海韵文博鉴信息科技有限公司 All rights reserved.
                <a
                    href="https://beian.miit.gov.cn/"
                    target="_blank"
                    class="link-item"
                    >沪ICP备18034058号-1</a
                >
            </div>
            <div class="desc-item">
                <router-link
                    :to="{ path: '/certificate/telecom' }"
                    class="link-item m-r-20"
                    >增值电信业务经营许可证：沪 B2-20190209</router-link
                >
                <router-link
                    :to="{ path: '/certificate/cultureManage' }"
                    class="link-item"
                    >网络文化经营许可证：沪网文（2019）0204-015号</router-link
                >
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Footer',
};
</script>
<style lang="scss" scoped>
.footer-container {
    padding-top: 36px;
    background: #373737;
    .logo-wrapper {
        display: block;
        width: 58px;
        height: 83px;
        margin: 0 auto 16px;
        img {
            width: 100%;
        }
    }
    .tag-list {
        text-align: center;
        font-size: 0;
        margin-bottom: 14px;
        .tag-item {
            display: inline-block;
            vertical-align: top;
            font-size: 12px;
            text-decoration: none;
            color: #c6c6c6;
        }
    }
    .link-info {
        margin-bottom: 23px;
        color: #c6c6c6;
        span {
            display: inline-block;
        }
    }
    .extro-desc {
        width: 100%;
        padding: 20px 0;
        background: #000;
        font-size: 12px;
        color: #c6c6c6;
        .desc-item {
            width: 100%;
            text-align: center;
            &.m-b-10 {
                margin-bottom: 10px;
            }
            .link-item {
                display: inline-block;
                vertical-align: top;
                text-decoration: none;
                color: #c6c6c6;
                &.m-r-20 {
                    margin-right: 20px;
                }
            }
        }
    }
}

@media screen and (min-width: 768px) {
    .link-info {
        text-align: center;
        font-size: 0;
        .link-method-item {
            display: inline-block;
            vertical-align: top;
            font-size: 12px;
            margin-right: 6px;
            &:last-of-type {
                margin-right: 0;
            }
        }
    }
}
@media screen and (max-width: 768px) {
    .link-info {
        .link-method-item {
            text-align: center;
            font-size: 12px;
            margin-bottom: 6px;
        }
    }
    .extro-desc {
        padding: 0 5px;
    }
}
</style>



// WEBPACK FOOTER //
// src/layout/components/Footer.vue